/*
Copyright 2019-present NAVER Corp.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
export const SQRT_2 = Math.sqrt(2);
export const SQRT_3 = Math.sqrt(3);

export const ISO_NONE = 0b0000;
export const ISO_LEFT = 0b0001;
export const ISO_RIGHT = 0b0010;
export const ISO_VERTICAL = 0b0100;
export const ISO_HORIZONTAL = 0b1000;

export const ISO_DEFAULT_SPACING = 40;
export const ISO_DEFAULT_ORIENTATION = ISO_VERTICAL | ISO_RIGHT;

export const ISO_DEFAULT_SIDE_COLOR = "grey";
export const ISO_DEFAULT_TOP_COLOR = "lightgrey";
